import React from 'react';

// eslint-disable-next-line max-len
const SELECTBRITY_LOGO = '/themes/theme/selectbrity/logo.png';
const SELECTBRITY_FULL_LOGO = '/themes/theme/selectbrity/logo-full.png';

const SelectbrityTheme = {
  headerLogo: {
    src: SELECTBRITY_LOGO,
    alt: 'Selectbrity Logo',
    size: 75,
  },
  darkLogo: {
    src: SELECTBRITY_LOGO,
    alt: 'Selectbrity Logo',
    size: 75,
  },
  linkStyle: {
    color: '#ffc800',
    fontWeight: 800,
    fontSize: '120%',
  },
  headerStyle: {
    backgroundColor: '#fff',
    borderBottom: '4px solid #003a5b',
    height: 80,
  },
  title: 'Selectbrity',
  organisationId: '99bcbe81-9f60-42bc-83a5-58994c1a351c',
  isLightOnDark: false,
  loginMessage: (
    <div style={{ padding: '10px' }}>
      <br /><br />
      <img
        height="100"
        src={SELECTBRITY_FULL_LOGO} alt="Selectbrity Logo"
      />
      <br /><br />
      {/* <h3>Selectbrity</h3> */}
    </div>
  ),
  shareSite: 'https://selectbrityr.dyzio.co',
};

export default SelectbrityTheme;



/** WEBPACK FOOTER **
 ** ./src/themes/theme/selectbrity.js
 **/